import { ref } from '@vue/composition-api'
import actionGateApi from '@/services/api/actionGate'

const STORAGE_KEY = 'actionGateToken'
const GATE_REQUIRED_STATUS = 428

function readToken() {
  const gate = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null')
  if (!gate || gate.expiresAt <= Date.now()) return null
  return gate.token
}

function storeToken(token, expiresAtSeconds) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ token, expiresAt: expiresAtSeconds * 1000 }))
}

function isGateRequired(err) {
  return err.response != null && err.response.status === GATE_REQUIRED_STATUS
}

export default function useActionGate() {
  const gateVisible = ref(false)
  const gateError = ref('')
  const gateLoading = ref(false)
  let pending = null

  function promptForPassword(action) {
    return new Promise((resolve, reject) => {
      pending = { action, resolve, reject }
      gateError.value = ''
      gateVisible.value = true
    })
  }

  async function runGated(action) {
    if (readToken()) {
      try {
        return await action()
      } catch (err) {
        if (!isGateRequired(err)) throw err
        return promptForPassword(action)
      }
    }
    return promptForPassword(action)
  }

  async function submitGatePassword(password) {
    gateLoading.value = true
    gateError.value = ''
    try {
      const { data } = await actionGateApi.verify(password)
      storeToken(data.data.token, data.data.expires_at)
      gateVisible.value = false
      const { action, resolve, reject } = pending
      pending = null
      try {
        resolve(await action())
      } catch (err) {
        reject(err)
      }
    } catch (err) {
      const data = err.response != null ? err.response.data : null
      gateError.value = data != null && data.message != null ? data.message : 'A server error occurred. Please try again later.'
    } finally {
      gateLoading.value = false
    }
  }

  function cancelGate() {
    gateVisible.value = false
    gateError.value = ''
    if (pending) {
      const err = new Error('Action cancelled by user.')
      err.isGateCancelled = true
      pending.reject(err)
      pending = null
    }
  }

  return {
    gateVisible, gateError, gateLoading, runGated, submitGatePassword, cancelGate
  }
}



// WEBPACK FOOTER //
// ./src/composables/useActionGate.js